module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section02_04_american-village-31aff8969ce005a21bdfb14971982bf1.jpg";